import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import AlertBanner from './alert-banner';
import type IntlService from 'ember-intl/services/intl';

export interface ErrorSignature {
  detail: string;
}

export type ErrorsSignature = {
  errors: ErrorSignature[];
};

interface ErrorMessagesSignature {
  Args: {
    error?: string | ErrorsSignature | null;
    icon?: string;
    iconClass?: string;
    listClass?: string;
    showErrors: boolean;
  };
  Element: HTMLDivElement;
}

export default class ErrorMessages extends Component<ErrorMessagesSignature> {
  @service declare intl: IntlService;

  get parsedErrorMessages() {
    const genericErrorMessage = this.intl.t('common.unknown_error_occurred');
    const error = this.args.error;
    if (typeof error === 'string') {
      return [error];
    } else if (error?.errors) {
      return error.errors.map((err) => {
        if (err?.detail === '[object Object]') {
          return genericErrorMessage;
        }
        return err?.detail || genericErrorMessage;
      });
    } else if (error) {
      return [genericErrorMessage];
    }
    return [];
  }

  <template>
    {{#if @showErrors}}
      {{#each this.parsedErrorMessages as |message|}}
        <AlertBanner @intent="warning" ...attributes>
          {{htmlSafe message}}
        </AlertBanner>
      {{/each}}
    {{/if}}
  </template>
}
